var PatientDocumentTypes = {
  DOCUMENTS: "documents",
  ESTIMATES: "estimates",
  BILLS: "bills",
  TECHNICAL_SHEETS: "technical_sheets",
};

module.exports = PatientDocumentTypes;
